export default __webpack_public_path__ + "static/media/ashish.446857d9.png";